/**
 * Guest-realm source for the Mail catcher extension. The tool is host-rendered
 * (components/mailCatcher/) and talks to the Rust mail_catcher_* commands
 * directly via invoke; captured mail never enters the guest sandbox. This
 * entry script is a no-op kept only to satisfy the extension registration
 * contract.
 */
export const mailCatcherEntrySource = `
(function () {
  var sdk = window.apibooSDK;
  sdk.onActivate(function () {});
})();
`;
